/**
 * @ngdoc directive
 * @name TableView
 *
 * @description
   Custom table with resizable columns, selectable rows (on keyup, keydown), pagination, ordered header
 *
 * @scope
 * @param  {String} sourceType - optional load, loadPerPage or datasource, datasource by default
 * @param  {Object} datasource - contain header settings, rows and footer;
 *                               rows used if sourceType = 'datasource'
 * @param  {Function} onRowClick - on row clicked event
 * @param  {Number} columnMinWidth - min column width, 50px by default
 * @param  {Number} columnMaxWidth - max column width, 400px by default
 * @param  {Number} pageSize - show rows per page, 20 by default
 * @param  {Number} onLoadData - load rows calback method, used if sourceType = 'calback'
 * @param  {Boolean} resizable: - is column resize allowed
 *
 * @example
 */

(function () {
  'use strict';

  TableView.$inject = ["PATH"];
  app.directive('tableView', TableView);

  function TableView(PATH) {
    controller.$inject = ["$scope", "$document", "$element", "$window", "$timeout", "hotkeys", "screenSizeService", "alertService"];
    return {
      replace: true,
      scope: {
        sourceType: '=?',
        datasource: '=',
        onRowClick: '&?',
        columnMinWidth: '=?',
        columnMaxWidth: '=?',
        pageSize: '=?',
        onLoadData: '&?',
        resizable: '=?',
        isShowAllMode: '=?',
        shouldInitGroupby: '=?',
        shouldActOnClick: '@?',
        id: '=?'
        // templateUrl: '=?'
      },
      restrict: 'E',
      templateUrl: PATH.components + 'tableView/template.html',
      controller: controller,
      link: function (scope, elem, attrs) {
        scope.hasOnRowClick = function () {
          return angular.isDefined(attrs.onRowClick);
        };
      }
    };

    function controller($scope, $document, $element, $window, $timeout, hotkeys, screenSizeService, alertService) {
      /**
       * Window resize event handling
       */
      angular.element($window).bind('resize', updateDisplayMode);


      /**
       * updateDisplayMode - display mode update
       */
      function updateDisplayMode() {
        $scope.isDesktop = screenSizeService.largerThan('md');
        $scope.isTablet = screenSizeService.largerThan('sm') && screenSizeService.smallerThan('md');
        $scope.isMobile = screenSizeService.smallerThan('sm');
        $scope.$apply($scope.isDesktop);
        $scope.$apply($scope.isMobile);
        $scope.refreshColumnsWidth();
      }

      /**
       * refreshColumnsWidth - get rendered table column width
       */
      $scope.refreshColumnsWidth = function () {
        var body = $element.find('.table-view__table-body');
        var header = $element.find('.table-view__table-header');

        if (body.length === 0) {
          return;
        }

        if (!$scope.pageRows.length) {
          return;
        }

        if ($scope.isDesktop || $scope.isTablet) {
          $scope.scrollbarWidth = body[0].offsetWidth - body[0].clientWidth;
          $scope.headerStyle = { paddingRight: $scope.scrollbarWidth + 'px' };
          var headerTitels = header.find('.table-view__header-cell a');
          angular.forEach(body.find('.table-view__column'), function (item, index) {
            if ($scope.columnOptions.header[index].width === 'auto') {
              $scope.columnOptions.header[index].width = $(headerTitels[index]).width() > item.clientWidth ? $(headerTitels[index]).width() + 20 : item.clientWidth + 20;
            } else {
              $scope.columnOptions.header[index].width = item.clientWidth;
            }
          });
          refreshCellStyles($scope.columnOptions.header);
        }
      };

      /**
       * onSortChange - on table sorting change event handler
       *
       * @param  {String} orderProp sorted column name
       */
      function sortDateQuote() {
        $scope.reverse = $scope.orderProperty === 'dateCreated' ? !$scope.reverse : false;
        $scope.datasource.reverse = $scope.reverse;
        var sortItems = $scope.rows.sort(function compare(itemA, itemB) {
          var dateA = 'dateClosed' in itemA ? itemA.dateClosed : itemA.dateCreated;
          var dateB = 'dateClosed' in itemB ? itemB.dateClosed : itemB.dateCreated;
          return new Date(dateA) - new Date(dateB);
        });
        if ($scope.reverse) sortItems = sortItems.reverse();
        $scope.rows = sortItems;
        $scope.goTo($scope.pager.currentPage);
      }

      function onSortChange(orderProp) {
        $scope.orderProperty = orderProp;
        $scope.datasource.orderBy = orderProp;
        if (orderProp === 'dateCreated') {
          sortDateQuote();
        } else {
          $scope.reverse = orderProp === $scope.orderProperty ? !$scope.reverse : false;
          $scope.datasource.reverse = $scope.reverse;
          if ($scope.sourceType !== 'loadPerPage') {
            var sortedItems = _.sortBy($scope.rows, function (item) {
              var properties = $scope.orderProperty.split('.');
              var value = item;
              properties.forEach(function (property) {
                value = value[property];
                if (typeof value === 'string') value = value.toLowerCase();
              });

              return value;
            });

            if ($scope.reverse) sortedItems = sortedItems.reverse();

            $scope.rows = sortedItems;
            $scope.goTo($scope.pager.currentPage);
          } else {
            loadPageRows($scope.pager.currentPage);
          }
        }
      }

      /**
       * onMouseOver - row cell mouse over event
       *
       * @param  {Number} index - hovered row index
       */
      $scope.onMouseOver = function (index, row) {
        if ($scope.isMobile || $scope.isTablet) {
          // safari iPad/Iphone action click fix
          onSelectRow(index, row);
          if ($scope.isTablet) {
            // tablet row hower higlight
            $scope.hoveredRowIndex = index;
            $scope.hoveredRow = row;
          }
        } else {
          $scope.hoveredRowIndex = index;
          $scope.hoveredRow = row;
        }
      };


      /**
       * onMouseLeave - on table mouse leave event
       */
      $scope.onMouseLeave = function () {
        $scope.hoveredRowIndex = -1;
        $scope.hoveredRow = undefined;
      };

      /**
       * onActionClick - on action click event
       */
      $scope.onActionClick = function (action, row, event) {
        if ($scope.selectedRowIndex !== -1 || $scope.shouldActOnClick) {
          action.callback(row);
          if (event) {
            event.preventDefault();
            event.stopPropagation();
          }
        }
      };

      /**
       * isActionShow - check is show action or not
       */
      $scope.isActionShow = function (action, row) {
        var isShow = false;

        if ((!row && $scope.selectedRowIndex !== -1) || (row && ($scope.selectedRow === row))) {
          isShow = !action.isShow || action.isShow($scope.selectedRow);
        }
        else if ((!row && $scope.hoveredRowIndex !== -1) || (row && ($scope.hoveredRow === row))) {
          isShow = !action.isShow || action.isShow($scope.hoveredRow);
        }

        return isShow;
      };

      /**
       * isActionsShow - check is show actions panel
       */
      $scope.isActionsShow = function (mode) {
        var res = false;
        if ($scope.isMobile) {
          res = $scope.datasource.mobile.actionsMode === mode;
        } else {
          res = $scope.datasource.desktop.actionsMode === mode;
        }
        return res;
      };

      /**
       * onClickOutside - on click outside of table event
       */
      $scope.onClickOutside = function (event) {
        if ($element[0].contains(event.target)) return;

        if ($scope.selectedRowIndex >= 0 || $scope.hoveredRowIndex >= 0) {
          $scope.selectedRowIndex = -1;
          $scope.selectedRow = undefined;
          $scope.hoveredRowIndex = -1;
          $scope.hoveredRow = undefined;
          $scope.$apply();
        }
      };

      /**
       * onResized - on column resize event
       */
      $scope.onResized = function () {
        refreshCellStyles();
        $scope.$apply($scope.header);
      };

      /* pagination */
      /**
       * paginate - do pagination for clint side paging
       */
      function paginate() {
        $scope.pager.totalCount = $scope.rows.length;
        $scope.goTo(0);
      }

      /**
       * goTo - go to page
       *
       * @param  {Number} pageNumber go to page
       */
      $scope.goTo = function (pageNumber) {
        var start, end;

        $scope.selectedRowIndex = -1;
        if ($scope.pager.totalCount < $scope.pager.pageSize) {
          $scope.page = undefined;
          $scope.pageRows = $scope.rows;
          $timeout(function () {
            $scope.refreshColumnsWidth();
          }, 0);
          return;
        }

        $scope.page = $scope.page || {};
        if ($scope.sourceType !== 'loadPerPage' || $scope.page.allMode) {
          start = pageNumber * $scope.pager.pageSize;
          end = (pageNumber + 1) * $scope.pager.pageSize;
          $scope.pageRows = $scope.page.allMode ? $scope.rows : $scope.rows.slice(start, end);
          $scope.pager.currentPage = pageNumber;
          $timeout(function () {
            $scope.refreshColumnsWidth();
          }, 0);
        } else {
          loadPageRows(pageNumber);
        }
      };

      /**
       * toggleAllMode - toggle all mode
       */
      $scope.toggleAllMode = function () {
        $scope.page.allMode = !$scope.page.allMode;
        if ($scope.sourceType === 'datasource') {
          $scope.isInit = false;
          paginate();
        } else if ($scope.sourceType === 'load') {
          loadRows();
        } else if ($scope.sourceType === 'loadPerPage') {
          if ($scope.page.allMode) {
            loadRows();
          } else {
            loadPageRows();
          }
        }
      };

      /**
       * loadRows - calback function should return promise with rows
       */
      function loadRows() {
        $scope.isLoading = true;
        $scope.onLoadData().then(function (response, status, headers) {
          var data = response.data;
          $scope.rows = $scope.pageRows = data;
          $scope.isLoading = false;
          $scope.isInit = false;
          $timeout(function () {
            $scope.refreshColumnsWidth();
          }, 0);
          paginate();
        }, function (reason) {
          if (reason) {
            alertService.error(reason.data[0].errorMessage);
          }
        });
      }

      /**
       * loadPageRows - load rows for server side pagination model
       *
       * @param  {Number} page page number to be load
       */
      function loadPageRows(page) {
        var loadPage = page || 0;
        $scope.isLoading = true;
        var loadData = $scope.onLoadData({
          page: loadPage,
          pageSize: $scope.pager.pageSize,
          sort: $scope.orderProperty,
          reverse: $scope.reverse
        });

        loadData.then(function (response, status, headers) {
          var data = response.data;
          $scope.pageRows = data;
          $scope.pager.totalCount = headers('x-total-count');
          if ($scope.pager.totalCount > $scope.pager.pageSize) {
            $scope.pager.currentPage = loadPage;
          }
          $scope.isLoading = false;
          $scope.isInit = false;
          $timeout(function () {
            $scope.refreshColumnsWidth();
          }, 0);
        }, function (reason) {
          alertService.error(reason.data[0].errorMessage);
        });
      }

      /**
       * onMouseClick - on row mose click event handler
       *
       * @param  {Object} event - mouse click event
       * @param  {Object} item clicked row item
       */
      $scope.onRowMouseClick = function (event, index, row) {
        if (event.button === 0 && !angular.element(event.target).hasClass('mod-button')) {
          initHotKeys();
          onSelectRow(index, row);
        }
      };

      /**
       * onSelectRow - select table row by index
       *
       * @param  {Number} index - row index
       */
      function onSelectRow(index, row) {
        if ($scope.hasOnRowClick && $scope.actions && ($scope.actions.length === 0) || $scope.shouldActOnClick) {
          $scope.onRowClick({
            item: row
          });
        } else if ($scope.hasOnRowClick) {
          var rowIndex = index > 0 ? index : 0;
          if (($scope.selectedRowIndex === -1) || ($scope.selectedRowIndex !== rowIndex)) {
            $scope.selectedRowIndex = rowIndex;
            $scope.selectedRow = row;
            event.stopPropagation();
            event.preventDefault();
          } else {
            $scope.onRowClick({
              item: row
            });
          }
        }
      }

      /**
       * onDownClicked - select next row when button down clicked
       *
       * @param  {Object} event - kebord button click event
       */
      function onDownClicked(event) {
        if (($scope.selectedRowIndex !== -1) && ($scope.selectedRowIndex < ($scope.pageRows.length - 1))) {
          $scope.selectedRowIndex++;
          $scope.selectedRow = $scope.pageRows[$scope.selectedRowIndex];
          event.stopPropagation();
          event.preventDefault();
        }
      }

      /**
       * onUpClicked - select prev row when button up clicked
       *
       * @param  {Object} event - kebord button click event
       */
      function onUpClicked(event) {
        if ($scope.selectedRowIndex > 0) {
          $scope.selectedRowIndex--;
          $scope.selectedRow = $scope.pageRows[$scope.selectedRowIndex];
          event.stopPropagation();
          event.preventDefault();
        }
      }

      /**
       * onEscClicked - escape from selected row
       */
      function onEscClicked() {
        $scope.selectedRowIndex = -1;
      }

      /**
       * refreshCellStyles - refressh cell inline css
       */
      function refreshCellStyles() {
        angular.forEach($scope.header, function (item) {
          var width = item.width === 'auto' ? item.width : item.width + 'px';
          var isShrink = item.isShrink === false ? 0 : 1;
          item.style = {
            flex: (isShrink ? 1 : 2) + ' ' + (isShrink ? 1 : 0) + ' ' + width,
            width: width,
            minWidth: $scope.columnMinWidth + 'px',
            maxWidth: (item.maxWidth || $scope.columnMaxWidth) + 'px'
          };
        });
      }

      /**
       * hotkeys - add event listeners to keyboard buttons
       */
      function initHotKeys() {
        hotkeys.bindTo($scope)
          .add({
            combo: 'tab',
            callback: onDownClicked
          })
          .add({
            combo: 'esc',
            callback: onEscClicked
          })
          .add({
            combo: 'up',
            callback: onUpClicked
          })
          .add({
            combo: 'down',
            callback: onDownClicked
          });

        if ($scope.hasOnRowClick) {
          hotkeys.bindTo($scope)
            .add({
              combo: 'enter',
              callback: function () { onSelectRow($scope.selectedRowIndex); }
            });
        }
      }

      /**
       * formatValue - format cell value
       *
       * @param  {Function} formatter - function that do formatting
       * @param  {String} value - cell value
       * @return {String} - formatted value
       */
      $scope.formatValue = function (formatter, prop, row) {
        var value = _.get(row, prop);
        return formatter ? formatter(value, row) : value;
      };

      function initTableGroupByDateAccepted(initparams) {
        if (initparams && initparams.includes('dateCreated')) {
          $scope.rows = _.orderBy($scope.rows, ['accepted', 'dateCreatedString'], ['asc', 'desc']);
          $scope.refreshColumnsWidth();
          refreshCellStyles($scope.columnOptions.header);
          paginate();
        }
      }

      /**
       * init - initialize data on load
       */
      function init() {
        /* set default values if not defined */
        // $scope.templateUrl = $scope.templateUrl || PATH.components + 'tableView/template.html';
        $scope.sourceType = $scope.sourceType || 'datasource';
        $scope.columnMinWidth = $scope.columnMinWidth || 50;
        $scope.columnMaxWidth = $scope.columnMaxWidth || 400;
        $scope.datasource.desktop.actionsMode = $scope.datasource.desktop.actionsMode || 'top';
        $scope.header = $scope.datasource.desktop.columns || [];
        $scope.datasource.mobile.actionsMode = $scope.datasource.mobile.actionsMode || 'none';
        $scope.mobile = $scope.datasource.mobile || [];
        $scope.actions = $scope.datasource.actions || [];
        $scope.rows = $scope.datasource.rows || [];
        $scope.footer = $scope.datasource.footer || [];
        $scope.pager = $scope.datasource.pager || {};
        $scope.pager.pageSize = $scope.pager.pageSize || 20;
        $scope.pager.isShowAllMode = $scope.pager.isShowAllMode || false;
        $scope.isDesktop = screenSizeService.largerThan('md');
        $scope.isTablet = screenSizeService.largerThan('sm') && screenSizeService.smallerThan('md');
        $scope.isMobile = screenSizeService.smallerThan('sm');
        $scope.selectedRowIndex = -1;
        $scope.hoveredRowIndex = -1;
        $scope.isInit = true;
        $scope.headerStyle = {};

        _.forEach($scope.header, function (item) {
          item.width = item.width || 'auto';
          item.class = item.class || 'mod-string';
          item.isResizable = typeof item.isResizable === 'undefined' ? true : item.isResizable;
          item.isSortable = item.isSortable === false ? false : true;
          item.type = item.type || 'string';
        });

        $scope.columnOptions = {
          header: $scope.header,
          columnMinWidth: $scope.columnMinWidth,
          columnMaxWidth: $scope.columnMaxWidth,
          clientWidth: $element[0].clientWidth
        };

        refreshCellStyles($scope.columnOptions.header);

        /* columns resize */
        $scope.column = null;

        /* sorting */
        $scope.orderProperty = $scope.datasource.orderBy || 'id';
        $scope.reverse = !$scope.datasource.reverse;
        $scope.setOrder = onSortChange;
        $scope.pageRows = [];
        onSortChange($scope.orderProperty);
        // safari mobile action click fix
        angular.element($window).on('click touchstart', function (event) {
          $scope.onClickOutside(event);
        });
        if ($scope.sourceType === 'datasource') {
          $scope.isInit = false;
          $scope.refreshColumnsWidth();
          refreshCellStyles($scope.columnOptions.header);
          paginate();
        } else if ($scope.sourceType === 'load') {
          loadRows();
        } else if ($scope.sourceType === 'loadPerPage') {
          loadPageRows();
        }

        $scope.actionsWidth = $element.context.offsetWidth;
      }

      init();
      initTableGroupByDateAccepted($scope.shouldInitGroupby);

      $scope.$on('tableViewDataRefresh', function (e, data) {
        if ($scope.sourceType === 'datasource') {
          $scope.isInit = false;
          $scope.refreshColumnsWidth();
          refreshCellStyles($scope.columnOptions.header);
          paginate();
        } else if ($scope.sourceType === 'load') {
          loadRows();
        } else if ($scope.sourceType === 'loadPerPage') {
          loadPageRows();
        }
      });

      $scope.$on('tableViewRowsRefresh', function (e, data) {
        if ($scope.pageRows.length && $scope.pageRows[0].dataStartDate) {
          $scope.rows = $scope.datasource.rows;
          $scope.pageRows = $scope.rows;
        }
      });
    }
  }
}());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/tableView/directive.js